export default __webpack_public_path__ + "static/media/NASSCOM.2a320242.png";